import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    name: '',
    type: null,
    source: '',
    file: '',
    device: [1, 2],
    status: 1,
    scheduled_from: null,
    scheduled_to: null,
    categories: []
}

export const advertisementSlice = createSlice({
    name: 'advertisement',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            if(payload.payload.type === "4"){
                payload.payload.device = [1];
            }
            if(payload.payload.type === "5"){
                payload.payload.device = [1,2];
            }
            if(payload.payload.type === "7"){
                payload.payload.device = [2];
            }
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = advertisementSlice.actions

export default advertisementSlice.reducer